import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { HiHome, HiFolder, HiUsers, HiDocumentText, HiChartBar, HiCog } from 'react-icons/hi';

export default function Sidebar() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <aside className={`${collapsed ? 'w-28' : 'w-64'} bg-white h-screen border-r hidden md:flex flex-col justify-between transition-all duration-200`}> 
      <div>
        <div className="p-6">
          <div className="text-xl font-bold text-gray-800 whitespace-nowrap overflow-hidden truncate">{!collapsed ? 'M3D Studio' : 'M3D'}</div>
        </div>

        <nav className="px-4">
          <ul className="space-y-2">
            <li>
              <div className="flex items-center gap-4 px-3 py-3 rounded-lg text-gray-400 bg-gradient-to-r from-gray-50 to-white">
                <HiHome className="w-5 h-5 text-gray-400" /> { !collapsed && <span className="font-medium">Dashboard</span> }
              </div>
            </li>
            <li>
              <Link to="/system/proposals" className="flex items-center gap-4 px-3 py-3 rounded-lg text-gray-700 hover:bg-gray-50">
                  <HiFolder className="w-5 h-5 text-gray-500" /> { !collapsed && <span>Orçamentos</span> }
                </Link>
            </li>
            <li>
              <div className="flex items-center gap-4 px-3 py-3 rounded-lg text-gray-400">
                <HiUsers className="w-5 h-5 text-gray-400" /> { !collapsed && <span>Clientes</span> }
              </div>
            </li>
            <li>
              <div className="flex items-center gap-4 px-3 py-3 rounded-lg text-gray-400">
                <HiDocumentText className="w-5 h-5 text-gray-400" /> { !collapsed && <span>Contratos</span> }
              </div>
            </li>
            <li>
              <div className="flex items-center gap-4 px-3 py-3 rounded-lg text-gray-400">
                <HiChartBar className="w-5 h-5 text-gray-400" /> { !collapsed && <span>Relatórios</span> }
              </div>
            </li>
            <li>
              <div className="flex items-center gap-4 px-3 py-3 rounded-lg text-gray-400">
                <HiCog className="w-5 h-5 text-gray-400" /> { !collapsed && <span>Configurações</span> }
              </div>
            </li>
          </ul>
        </nav>
      </div>

      <div className="p-4 border-t">
        <button onClick={() => setCollapsed(!collapsed)} className="w-fit flex items-center justify-center gap-3 px-3 py-3 h-12 rounded-lg text-gray-600 hover:bg-gray-50">
          <span className="text-base">{collapsed ? 'Abrir menu' : 'Recolher menu'}</span>
        </button>
      </div>
    </aside>
  );
}
